import HealthStatusChip from "Components/molecule/health-status-chip"
import { HealthStatus, ProjectHealthHistoryItem, ProjectHealthUI } from "models/project-health"

interface HealthHistoryProps {
    history: ProjectHealthHistoryItem[]
    // Live status of the current period, shown first
    currentPeriod: number
    currentStatus: HealthStatus | null
    currentFailing: ProjectHealthHistoryItem["failingChecks"]
}

// Monthly status trail: live month first, then frozen snapshots (newest first).
const HealthHistory = ({ history, currentPeriod, currentStatus, currentFailing }: HealthHistoryProps) => {
    const past = history.filter(h => h.fiscalPeriod !== currentPeriod)

    return (
        <div className="health-history">
            {currentStatus && (
                <div className="month current">
                    <small>{ProjectHealthUI.periodLabel(currentPeriod)} <span className="muted">(live)</span></small>
                    <HealthStatusChip status={currentStatus} failingChecks={currentFailing} tooltipId={`hist-live-${currentPeriod}`} />
                </div>
            )}
            {past.map(h => (
                <div className="month" key={h.fiscalPeriod}>
                    <small>{ProjectHealthUI.periodLabel(h.fiscalPeriod)}</small>
                    <HealthStatusChip status={h.status} failingChecks={h.failingChecks} tooltipId={`hist-${h.fiscalPeriod}`} />
                </div>
            ))}
            {past.length === 0 && (
                <span className="muted">No monthly snapshots yet. They are saved when each period closes.</span>
            )}
        </div>
    )
}

export default HealthHistory
